import useAppStore from '../stores/app'

const useUserIsReadOnly = () => {
  const isReadOnly = useAppStore(state => state.user?.is_read_only)

  return isReadOnly ?? true
}

export default useUserIsReadOnly
